import React from 'react'
import GgGolfHubPopup from '../shared/gg_golf_hub_popup'
import PropTypes from 'prop-types'

const MemberDeletePopup = ({ isOpen, title, onDelete, onClose }) => {
  if (!isOpen) { return null }
  return (
    <div>
      <GgGolfHubPopup isOpen={isOpen} confirmText={window.I18n.t('buttons.delete')} onConfirm={onDelete} onClose={onClose} title={window.I18n.t('gg_golf_hub.member_delete_popup.title')}>
        {title}
      </GgGolfHubPopup>
    </div>
  )
}

MemberDeletePopup.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  onDelete: PropTypes.func,
  onClose: PropTypes.func,
}

export default MemberDeletePopup
